import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logProUpsellFunFactShownParams = {
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  trigger?: UpsellTrigger;
};

/**
 * User sees the entirety of the fun fact dialog at the bottom of the upsell screen.
 * @param params - Attributes to log with the amplitude event
 * @param params.is_free_7_day_trial - Deprecated use in 2025. TRUE if the user is being shown (i.e. eligible for) the Free 7-Day Trial option, FALSE if the user is being shown the Annual option only.
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.trigger - Action that triggered the upsell to display
 */
const logProUpsellFunFactShown = ({ purchase_screen_type_plan, trigger }: logProUpsellFunFactShownParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('pro upsell fun fact shown', { 'purchase screen type plan': purchase_screen_type_plan, trigger }, callback);
};

export default logProUpsellFunFactShown;
